import { mapActions } from 'vuex';
import { SUPPORT_SETTINGS_TYPE } from '~/constants/_core/support-settings-type';
import { FloatingSupportListener } from '~/helpers/_core/floating-support';

export default {
  data() {
    return {
      supportSetting : null,
      blip           : {
        src      : 'https://unpkg.com/blip-chat-widget',
        instance : null
      }
    };
  },
  created() {
    FloatingSupportListener.addEventListener(this.handleEvent);
  },
  computed: {
    hasSupportWhatsApp() {
      return this.supportSetting?.type === SUPPORT_SETTINGS_TYPE.WHATSAPP;
    },
    supportSettingClasses() {
      const classes = ['floating-support'];
      const floatingClasses = {
        'bottom_left'  : 'floating-support--bottom-left',
        'bottom_right' : 'floating-support--bottom-right',
        'top_left'     : 'floating-support--top-left',
        'top_right'    : 'floating-support--top-right'
      };

      if (this.supportSetting) {
        classes.push(floatingClasses[this.supportSetting.position]);
      }

      return classes;
    },
    tooltipConfig() {
      const [_, position] = this.supportSetting.position.split('_');
      const isFloatingSupportLeftPosition = position === 'left';
      const config = {
        position   : isFloatingSupportLeftPosition ? 'right' : 'left',
        nudgeRight : isFloatingSupportLeftPosition ? 10 : 0,
        nudgeLeft  : isFloatingSupportLeftPosition ? 0 : 10
      };

      return config;
    },
    floatingSupportEnable() {
      return process.env.INTEGRATE_MODULE_API && process.env.INTEGRATE_MODULE_API_KEY;
    }
  },
  methods: {
    ...mapActions({
      actionGetAllSupportSettings: '_core/supportSettings/actionGetAllSupportSettings'
    }),
    async getAllSupportSettings(supportSettingSectorAlias) {
      try {
        const { results } = await this.actionGetAllSupportSettings({ isActive: true });
        this.filterSupportSettingBySectorAlias(results, supportSettingSectorAlias);
      } catch (error) {
        console.error(error);
      }
    },
    handleEvent(event) {
      if (!this.floatingSupportEnable) {
        return;
      }

      const { detail: { supportSettingSectorAlias } } = event;

      if (supportSettingSectorAlias) {
        this.getAllSupportSettings(supportSettingSectorAlias);
      } else {
        this.removeSupportScript(this.supportSetting?.type);
        this.supportSetting = null;
      }
    },
    filterSupportSettingBySectorAlias(supportSettings, supportSettingSectorAlias) {
      const support = supportSettings?.find(support =>
        support.sectors.some(({ sector }) => sector.alias === supportSettingSectorAlias)
      );

      if (!support) {
        return;
      }

      this.supportSetting = support;
      const { template, type } = support;

      this.executeSupportScript(type, template);
    },
    executeSupportScript(type, template) {
      const execute = {
        [SUPPORT_SETTINGS_TYPE.BLIP]: this.executeBlipScript
      };

      if (execute[type]) {
        execute[type](template);
      }
    },
    removeSupportScript(type) {
      if (!type) {
        return;
      }

      const execute = {
        [SUPPORT_SETTINGS_TYPE.BLIP]: this.removeBlipScript
      };

      if (execute[type]) {
        execute[type]();
      }
    },
    loadScript(onload, src, scriptName) {
      if (document.querySelector(`script[src="${src}"]`)) {
        setTimeout(onload, 1000);
        return;
      }

      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.onload = () => {
        setTimeout(onload, 500);
      };

      script.onerror = () => {
        console.error(this.$t('_core.floatingSupport.errors.loadingScript', {
          scriptName
        }));
      };

      document.head.appendChild(script);
    },
    openWhatsApp() {
      const { cellphone, message } = this.supportSetting;
      const encodedMessage = encodeURIComponent(message);
      const whatsappUrl = `https://wa.me/${cellphone}?text=${encodedMessage}`;
      window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    },
    executeBlipScript(template) {
      const { appKey, color, customCommonUrl } = template;

      const initBlipChat = () => {
        if (typeof window.BlipChat === "function") {
          this.blip.instance = new BlipChat()
            .withAppKey(appKey)
            .withButton({ "color": color, "icon": "" })
            .withCustomCommonUrl(customCommonUrl);

          this.blip.instance.build();
        } else {
          setTimeout(initBlipChat, 500);
        }
      };

      if (!window.BlipChat) {
        this.loadScript(
          initBlipChat,
          this.blip.src,
          SUPPORT_SETTINGS_TYPE.BLIP
        );
      } else {
        initBlipChat();
      }
    },
    removeBlipScript() {
      this.blip.instance.destroy();
    }
  }
};
